import { useState } from 'react';
import { requestLoginCode, verifyLoginCode } from '../lib/altYApi';

// Email one-time-code sign-in. The broker emails a 6-digit code to allowlisted
// addresses; verifying it sets the session cookie.
export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function sendCode() {
    setBusy(true);
    setError('');
    try {
      await requestLoginCode(email.trim());
      setStep('code');
    } catch (e) {
      setError((e as Error).message || 'could not send the code');
    } finally {
      setBusy(false);
    }
  }

  async function verify() {
    setBusy(true);
    setError('');
    try {
      await verifyLoginCode(email.trim(), code.trim());
      onSignedIn();
    } catch (e) {
      setError((e as Error).message || 'incorrect code');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="alty-login">
      <div className="alty-login-card">
        <div className="alty-login-brand">Alt-Y</div>
        {step === 'email' ? (
          <>
            <p>Sign in with your email — a one-time code will be sent to you.</p>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              autoFocus
              onChange={(event) => setEmail(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && email.trim() && !busy) void sendCode();
              }}
            />
            <button type="button" onClick={() => void sendCode()} disabled={busy || !email.trim()}>
              {busy ? 'Sending…' : 'Send code'}
            </button>
          </>
        ) : (
          <>
            <p>Enter the 6-digit code sent to <strong>{email}</strong>.</p>
            <input
              inputMode="numeric"
              placeholder="000000"
              value={code}
              autoFocus
              onChange={(event) => setCode(event.target.value.replace(/\D/g, '').slice(0, 6))}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && code.trim() && !busy) void verify();
              }}
            />
            <button type="button" onClick={() => void verify()} disabled={busy || !code.trim()}>
              {busy ? 'Verifying…' : 'Sign in'}
            </button>
            <button
              type="button"
              className="alty-login-link"
              onClick={() => {
                setStep('email');
                setCode('');
                setError('');
              }}
            >
              Use a different email
            </button>
          </>
        )}
        {error ? <div className="alty-login-error">{error}</div> : null}
      </div>
    </div>
  );
}
